<template>
<div class="col-12" v-if="condition">
<Dropdown 
:filter="true"  
v-model="condition.selected_input" 
:options="theinputs" 
optionLabel="name"   
class=" p-inputtext-sm mt-2 w-4" 
@change="inputSelected"/>

<template  v-if="condition.selected_input && condition.selected_input.id!=='unconditionally'">

<span class="ml-2" v-if="condition.selected_input.type !=='flow_status' && condition.selected_input.type !=='project_status'">
için değer
</span>

<Dropdown 
:filter="false"  
v-if="condition.selected_input.type !=='flow_status' && condition.selected_input.type !=='project_status'"
v-model="condition.comparison_type" 
:options="comparison_types" 
optionLabel="name" 
optionValue="code" 
class="ml-2 p-inputtext-sm mt-2" 
@change="comparisonTypeSelected"
/>
</template>



<template v-if="condition.comparison_type">
	<!-- input-->
	<template v-if="condition.comparison_type=='input'">
	<Dropdown 
	:filter="true"   
	v-model="condition.comparison_input" 
	:options="inputs" 
	optionLabel="name"  
	class="ml-2 p-inputtext-sm mt-2 w-4"  
	@change="comparisonInputSelected"/>	


	<template v-if="condition.selected_input && condition.selected_input.type=='custom_attribute' && customattribute">

			<Dropdown  
			v-if="customattribute.type=='number'"
			:options="numberoperators"
			v-model="condition.execution_type"  
			optionLabel="name" 
			optionValue="code" 
			class="ml-2 p-inputtext-sm mt-2" 
			@change="conditionExecutionSelected"/>

			<Dropdown  
			v-if="customattribute.type=='select' || customattribute.type=='boolean'"
			:options="selectoperators" 
			v-model="condition.execution_type" 
			optionLabel="name" 
			optionValue="code" 
			class="ml-2 p-inputtext-sm mt-2" 
			@change="conditionExecutionSelected"/>

			<Dropdown  
			v-if="customattribute.type=='string'"
			:options="textoperators" 
			v-model="condition.execution_type" 
			optionLabel="name" 
			optionValue="code" 
			class="ml-2 p-inputtext-sm mt-2" 
			@change="conditionExecutionSelected"/>			
			
	</template>


	

	


	</template>
	<!-- input-->
	<!-- value-->
	<template v-if="condition.comparison_type=='value'">

	<!-- condition value-->
	<Dropdown 
	:filter="true" 
	v-if="condition.selected_input.type=='project_status' || condition.selected_input.type=='flow_status'"
	v-model="condition.text_val" 
	:options="status_operators" 
	optionLabel="name" 
	optionValue="code" 
	class="ml-2 p-inputtext-sm mt-2" />

	<InputNumber  
	placeholder="Sayısal değeri" 
	v-if="condition.selected_input.type=='questionlist_points' || condition.selected_input.type=='questionlist_custom_points' || condition.selected_input.type=='questionlist_nonconformity_count' || condition.selected_input.type=='section_points' || condition.selected_input.type=='section_nonconformities' || condition.selected_input.type=='inputfield_point' " 
	v-model="condition.numerical_val" 
	class="ml-2 p-inputtext-sm mt-2" />


	<InputText  
	type="text" 
	placeholder="Text değeri" 
	v-if="condition.selected_input.type=='supplier_location' || condition.selected_input.type=='supplier_users' || condition.selected_input.type=='last_supplier_conversation'" 
	v-model="condition.text_val" 
	class="ml-2 p-inputtext-sm mt-2" />

	<template v-if="condition.selected_input.type=='inputfield_submission'">
		
	</template>

	<Dropdown 
	:filter="true" 
	v-if="condition.selected_input.type=='inputfield_null_reason' 
	|| condition.selected_input.type=='verification_auditor'
	|| condition.selected_input.type=='audit_auditor' 
	|| condition.selected_input.type=='inputfield_nonconformity_count'" 
	v-model="condition.numerical_val" 
	:options="condition_options" 
	optionLabel="name" 
	optionValue="id" 
	class="ml-2 p-inputtext-sm mt-2" />
	<!-- condition value-->

	<template v-if="condition.selected_input.type=='custom_attribute' && customattribute">
			<InputNumber  
			placeholder="Sayısal değeri" 
			v-if="customattribute.type=='number'" 
			v-model="condition.numerical_val" 
			class="ml-2 p-inputtext-sm mt-2" 
			@change="conditionExecutionSelected"/>
			<Dropdown  
			v-if="customattribute.type=='select'" 
			v-model="condition.execution_type" 
			:options="customattribute.options" 
			optionLabel="name" 
			optionValue="code" 
			class="ml-2 p-inputtext-sm mt-2" 
			@change="conditionExecutionSelected"/>
			<Dropdown  
			v-if="customattribute.type=='boolean'" 
			v-model="condition.execution_type" 
			:options="booleanoptions" 
			optionLabel="name" 
			optionValue="code" 
			class="ml-2 p-inputtext-sm mt-2" 
			@change="conditionExecutionSelected"/>
			<InputText  
			type="text" 
			placeholder="Text değeri" 
			v-if="customattribute.type=='string'" 
			v-model="condition.text_val" 
			class="ml-2 p-inputtext-sm mt-2" 
			@change="conditionExecutionSelected"/>

			<Dropdown  
			v-if="customattribute.type=='number'"
			:options="numberoperators"
			v-model="condition.execution_type"  
			optionLabel="name" 
			optionValue="code" 
			class="ml-2 p-inputtext-sm mt-2" 
			@change="conditionExecutionSelected"/>

			<Dropdown  
			v-if="customattribute.type=='select' || customattribute.type=='boolean'"
			:options="selectoperators" 
			v-model="condition.execution_type" 
			optionLabel="name" 
			optionValue="code" 
			class="ml-2 p-inputtext-sm mt-2" 
			@change="conditionExecutionSelected"/>

			<Dropdown  
			v-if="customattribute.type=='string'"
			:options="textoperators" 
			v-model="condition.execution_type" 
			optionLabel="name" 
			optionValue="code" 
			class="ml-2 p-inputtext-sm mt-2" 
			@change="conditionExecutionSelected"/>	

		</template>



	</template>
	<!-- value-->

	<!-- condition operation-->

	<Dropdown  
	v-if="condition.selected_input.type=='questionlist_points' 
	|| condition.selected_input.type=='questionlist_custom_points'
	|| condition.selected_input.type=='questionlist_nonconformity_count'
	|| condition.selected_input.type=='section_points'
	|| condition.selected_input.type=='section_nonconformities'
	|| condition.selected_input.type=='inputfield_point'"
	v-model="condition.execution_type" 
	:options="numberoperators" 
	optionLabel="name" 
	optionValue="code" 
	class="ml-2 p-inputtext-sm mt-2" 
	@change="conditionExecutionSelected"/>

	<Dropdown  
	v-if="condition.selected_input.type=='supplier_location' 
	|| condition.selected_input.type=='supplier_users'
	|| condition.selected_input.type=='last_supplier_conversation'
	|| condition.selected_input.type=='verification_auditor'
	|| condition.selected_input.type=='audit_auditor'"
	v-model="condition.execution_type"
	:options="textoperators" 
	optionLabel="name" 
	optionValue="code" 
	class="ml-2 p-inputtext-sm mt-2" 
	@change="conditionExecutionSelected"/>

	<Dropdown  
	v-if="condition.selected_input.type=='project_status' 
	|| condition.selected_input.type=='flow_status'
	|| condition.selected_input.type=='inputfield_null_reason'
	|| condition.selected_input.type=='inputfield_nonconformity_count'"
	v-model="condition.execution_type" 
	:options="selectoperators" 
	optionLabel="name" 
	optionValue="code" 
	class="ml-2 p-inputtext-sm mt-2" 
	@change="conditionExecutionSelected"/>




	

	<!-- condition operation-->


</template>

	

<template v-if="condition.execution_type">
<Dropdown  v-model="condition.operator" :options="conditionoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm mt-2" @change="conditionOperatorSelected"/>
</template>

<Button icon="pi pi-trash"  class="p-button-outlined p-button-sm p-button-danger ml-2 mt-2"   @click="removeCondition"></Button>

<div class="grid"><div class="col-12"><hr></div></div>


</div>
</template>

<script>
const condition_obj = {
	id:null,
	type:null,//inputfield,customattribute
	comparison_type:null,
	selected_input:null,
	comparison_input_id:null,
	text_val:null,
	numerical_val:null,
	execution_type:null,
	operator:null,
	
}

export default {

  name: 'LogicBundleConditionLine',
  props:["thecondition","inputs"],
  data () {
    return {
    	condition:null,  
    	theinputs:[],
    	selected_input:null,  		
    	ready_to_include:false,
    	condition_options:[],    	
		  customattribute:null,
		  inputfield:null,
    	condition_type:"numerical",
    	comparison_types:[
	    	{name:"Veri",code:"input"},
	    	{name:"Tam Değer",code:"value"},
    	],
    	status_operators:[
	    	{name:"Oluşturuldu",code:"created"},
	      {name:"Görüntülendi",code:"viewed"},
	    	{name:"Başlandı",code:"started"},
	    	{name:"Değerlendirmede",code:"under_review"},
	      {name:"Tamamlandı",code:"finished"},        
	      {name:"Düzeltme Talep Edildi",code:"correction_requested"},
	      {name:"İptal Edildi",code:"canceled"},
	    	{name:"Silindi",code:"deleted"},
    	],
    	textoperators:[
	    	{name:"Terimini içeriyorsa",code:"includes"},
	    	{name:"Terimini içermiyorsa",code:"does_not_include"},
    	],
    	numberoperators:[
	    	{name:"değerine eşitse",code:"equal_to"},
	    	{name:"değerine eşit değilse",code:"not_equal_to"},
	    	{name:"değerinden büyükse",code:"greater_than"},
	    	{name:"değerinden küçükse",code:"less_than"},
	    	{name:"değer mevcutsa",code:"input_filled"},
    	],
    	selectoperators:[
	    	{name:"değerine eşitse",code:"equal_to"},
	    	{name:"değerine eşit değilse",code:"not_equal_to"},
    	],
    	booleanoptions:[
	    	{name:"Açık",code:1},
	    	{name:"Kapalı",code:0},
    	],
    	conditionoperators:[
	    	{name:"ve",code:"and"},
	    	{name:"ya da",code:"or"},
	    	{name:"tamamla",code:"execute"},
    	],
    }
  },
  mounted()
  {
  	this.condition = this.thecondition
  	this.generateInputs()
  },
  methods:{
  	comparisonTypeSelected()
  	{
  		if(this.condition.comparison_type=="value" && this.condition.selected_input.type=="custom_attribute")
  		{
  			this.getCustomfieldData(this.condition.selected_input.id)
  		}
  		if(this.condition.comparison_type=="value" && this.condition.selected_input.type=="inputfield_submission")
  		{
  			this.getInputfieldData()
  		}
  	},
  	generateInputs()
  	{
  		this.theinputs = []
  		this.theinputs.push({name:"Koşulsuz olarak",id:"unconditionally"})
  		this.theinputs = this.theinputs.concat(this.inputs)
  	},
  	removeCondition()
  	{
  		this.$emit("removeCondition",this.condition.id)
  	},
  	inputSelected()
  	{
  		console.log(this.condition)
  		if(this.condition.selected_input.type=="flow_status" || this.condition.selected_input.type=="project_status")
  		{
  			this.condition.comparison_type = "value"
  		}
  		if(this.condition.selected_input.id=="unconditionally")
  		{
  			this.condition.operator = "execute"
  		}
  		
  		this.$emit("conditionUpdated",{condition:this.condition})
  	},
  	comparisonInputSelected()
  	{
  		console.log(this.condition)
  		this.$emit("conditionUpdated",{condition:this.condition})
  		if(this.condition.comparison_input.type=="custom_attribute")
  		{
  			this.getCustomfieldData(this.condition.comparison_input.id)
  		}
  		if(this.condition.comparison_input.type=="inputfield_submission")
  		{
  			this.getInputfieldData()
  		}

  	},
  	conditionExecutionSelected()
  	{
  		this.ready_to_include = true
  		this.$emit("conditionUpdated",{condition:this.condition})
  	},
  	conditionOperatorSelected()
  	{
  		this.$emit("conditionUpdated",{condition:this.condition})
  	},
  	async getInputfieldData()
  	{
  		this.customattribute = await this.generalApiGetWithoutLoader("questionlists/inputfield/"+this.condition.comparison_input.id)
  		
  	},
  	async getCustomfieldData(id)
  	{
  		console.log("getCustomfieldData")
  		this.customattribute = await this.generalApiGetWithoutLoader("custom_attributes/brand_attribute/"+id)
  		console.log(this.customattribute)
  		
  	},
  },
}
</script>

<style lang="css" scoped>
</style>